import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { AbstractReportComponent } from '../abstract.report.component';
import { DealerLogin, DealerLoginParamterData, DealersLastestLogin } from '../models/dealer.latest.login.interface';
import { Dealer } from '../../shared/models/dealer.interface';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DealerService } from '../../dealer/services/dealer.service';
import { FileService } from '../../shared/services/file.service';
import { ReportService } from '../services/report.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-dealers-latest-login',
  templateUrl: './dealers-latest-login.component.html',
  styleUrl: './dealers-latest-login.component.scss'
})
export class DealersLatestLoginComponent extends AbstractReportComponent implements OnInit {
  report: DealersLastestLogin = null;
  parameters: DealerLogin = {
    dealer_ID: null,
    status: 1,

  } as DealerLogin;

  dealer: Dealer;
  dealers: Dealer[];
  status_Desc: string = '';
  isRequesting: boolean = false;

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    dialog: MatDialog, private dealerService: DealerService, private fileService: FileService,
    private reportService: ReportService) {
    super(locale, dialog, deviceDetectorService);
  }

  ngOnInit() {
    this.isRequesting = true;
    this.dealerService.getList()
      .subscribe({
        next: (data) => {          
          this.dealers = data;
          this.isRequesting = false;
          this.status_Desc = $localize`Active`;          
          this.showParameters();
        }
      });
  }

  renderReport() {
    this.getReportFormat()
      .subscribe(formatData => {
        if (formatData == null) return;

        this.isRequesting = true;

        this.dealerService.getDealerLoginExport(this.parameters, formatData.format)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.fileService.downloadFile(data, 'dealerLogin' + formatData.extension);
            }
          });
      });
  }

  loadReport() {
    // wait until dropdowns loaded
    if (this.dealers == null)
      return;

    this.isRequesting = true;
    this.dealer = this.dealers.find(s => s.dealer_ID == this.parameters.dealer_ID);

    this.dealerService.getDealerLoginReport(this.parameters)
      .subscribe({
        next: (data) => {
          this.report = data;
          this.isRequesting = false;
        }
      });
  }

  showParameters() {
    // wait until dropdowns loaded
    if (this.dealers == null)
      return;

    const dialogRef = this.dialog.open(DealerLoginParameterDialog, {
      width: '550px',
      data: {
        dealerLogin: (<any>Object).assign({}, this.parameters),

        dealers: this.dealers,

      }
    });

    dialogRef.afterClosed().subscribe((result: DealerLoginParamterData)  => {
      console.log('The dialog was closed');
      if (result) {
       
        this.parameters = result.dealerLogin as DealerLogin;

        this.status_Desc = this.parameters.status === null ? $localize`All` : this.parameters.status === 1 ? $localize`Active` : $localize`Inactive`;
        this.dealer = this.dealers.find(s => s.dealer_ID == this.parameters.dealer_ID);

        this.isRequesting = true;
        this.dealerService.getDealerLoginReport(this.parameters)
          .subscribe({
            next: (data) => {
              this.isRequesting = false;
              this.report = data;
            },
            error: (error: string) => this.onError(error)
          });
      }
    });
  }
}

@Component({
  selector: 'dealer-login.parameter.dialog',
  templateUrl: 'dealer-login.parameter.dialog.html',
})
export class DealerLoginParameterDialog {

  constructor(
    public dialogRef: MatDialogRef<DealerLoginParameterDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DealerLoginParamterData) { }

  runReport(form: NgForm): void {
    if (form.valid) {
      this.dialogRef.close(this.data);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
